import { Grid, Typography } from '@mui/material'
import { Box } from 'components'
import { NO_IMAGE } from 'config'

export const MaterialItemList = (props: any) => {
  const { item, onClick, style } = props
  return (
    <div style={style}>
      <Box
        style={{
          flex: 1,
          display: 'flex',
          borderBottom: '0.5px solid #dedede',
          minHeight: 100
        }}
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.1)'
          },
          '&:active': {
            backgroundColor: 'rgba(255,255,255,0.2)'
          }
        }}
      >
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <img
            height={110}
            width={110}
            loading="lazy"
            src={item?.product?.imageUrl || item?.imageUrl || NO_IMAGE}
            style={{ objectFit: 'contain', backgroundColor: 'white' }}
          />
        </Box>

        <div style={{ flex: 1 }} onClick={onClick}>
          <Grid container>
            <Grid item xs={12} ml={1} mt={0.5}>
              <Typography variant="caption" color="#262626">
                {item?.product?.id || item?.id} |{' '}
                {item?.product?.reference || item?.reference}
              </Typography>
            </Grid>
            <Grid item xs={12} ml={1} mt={0.5}>
              <Typography variant="body2" fontWeight="bold">
                {item?.product?.name || item?.name}
              </Typography>
            </Grid>
            {/* <Grid container item xs={12} ml={1} mt={0.5}>
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  color={
                    item?.stock === undefined || item?.stock > 0 ? '' : 'red'
                  }
                  fontWeight={
                    item?.stock === undefined || item?.stock > 0 ? '' : 'bold'
                  }
                >
                  {formatNumber(item?.stock)}{' '}
                  {item?.product?.unitMeasure || item?.unitMeasure || ''}
                </Typography>
              </Grid>
            </Grid> */}
          </Grid>
        </div>
      </Box>
    </div>
  )
}
